import { Button, FileInput, Stack } from "@mantine/core"
import { modals } from "@mantine/modals"
import { useMutation } from "@tanstack/react-query"
import { useState } from "react"
import { useTranslation } from "react-i18next"
import { useConfirm } from "@/hooks"
import { notifySuccess } from "@/utils"

interface IProps {
  hint: string
  /** Uploads the file and returns the success notification message. */
  action: (file: File) => Promise<string>
}

export function CSVImport({ hint, action }: IProps) {
  const { t } = useTranslation()
  const [file, setFile] = useState<File | null>(null)

  const confirmImport = useConfirm({
    title: t("Import CSV"),
    children: `${t("Existing data will be updated.")} ${t("Do you want to proceed?")}`,
  })

  const { mutate, isPending } = useMutation({
    mutationFn: action,
    onSuccess: (message) => {
      notifySuccess({ t, message })
      modals.closeAll()
    },
  })

  return (
    <Stack>
      <FileInput
        accept=".csv,text/csv"
        clearable
        label={t("Import CSV")}
        placeholder={t("Upload file")}
        description={hint}
        value={file}
        onChange={setFile}
      />
      <Button
        disabled={!file || isPending}
        onClick={async () => {
          if (file && (await confirmImport())) mutate(file)
        }}
      >
        {t("Upload file")}
      </Button>
    </Stack>
  )
}
